module.exports = __webpack_public_path__ + "4df3f5358b88af910f4eeaa959e282f4.jpg";